import zod from 'zod';

export const customersDataSchema = zod.object({
  data: zod.array(
    zod.object({
      id: zod.string(),
    })
  ),
  meta: zod.object({
    current_account_id: zod.string(),
    next_page: zod.number().nullable(),
    page_size: zod.number(),
    total_entries: zod.number(),
    total_pages: zod.number(),
  }),
});

export type CustomerDataSchema = ReturnType<typeof customersDataSchema.parse>;

export type FetchCustomersData = (customerExternalId: string) => Promise<CustomerDataSchema>;
